module.exports = __webpack_public_path__ + "static/media/Logo_TransMedia_Pustaka.7a9f45ac.png";